var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatsInactiveLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#DFE5F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_chat_inactive_light)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.0306 27) scale(1.22449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8 17.5L13 21L10.2 17.5H5C4.73478 17.5 4.48043 17.3946 4.29289 17.2071C4.10536 17.0196 4 16.7652 4 16.5V5.603C4 5.33778 4.10536 5.08343 4.29289 4.89589C4.48043 4.70836 4.73478 4.603 5 4.603H21C21.2652 4.603 21.5196 4.70836 21.7071 4.89589C21.8946 5.08343 22 5.33778 22 5.603V16.5C22 16.7652 21.8946 17.0196 21.7071 17.2071C21.5196 17.3946 21.2652 17.5 21 17.5H15.8ZM1 0.5H18V2.5H2V13.5H0V1.5C0 1.23478 0.105357 0.98043 0.292893 0.792893C0.48043 0.605357 0.734784 0.5 1 0.5Z",
    fill: "#181D24"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_chat_inactive_light"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 25.7143,
    fill: "white",
    transform: "translate(24.5 27)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatsInactiveLight);
export default __webpack_public_path__ + "static/media/ChatsInactiveLight.00aa70aff748367be527f9e0b4f23784.svg";
export { ForwardRef as ReactComponent };